import { resolveNodeSettings } from './viewTree/nodes/NodeSettings';
export function hasUserData(node) {
    return Object.keys(node.userData).length > 0;
}
export function getUserData(node) {
    return resolveNodeSettings(node.userData);
}
export function setUserData(node, data) {
    node.userData = resolveNodeSettings(data);
}
export function changeUserData(node, data) {
    node.userData = resolveNodeSettings(Object.assign(Object.assign({}, node.userData), data));
}
//# sourceMappingURL=types.js.map